import { cva } from 'class-variance-authority'

export const josefButtonVariants = cva(
  // Base styles - always applied
  'inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 active:scale-[0.98]',
  {
    variants: {
      variant: {
        // Primary - Black background, white text (light mode) / White background, black text (dark mode)
        primary:
          'bg-black text-white border border-black hover:bg-gray-800 active:bg-gray-900 focus-visible:ring-gray-500 dark:bg-white dark:text-black dark:border-white dark:hover:bg-gray-100 dark:active:bg-gray-200 dark:focus-visible:ring-gray-400',

        // Secondary - Light gray background, black text (light mode) / Dark gray background, white text (dark mode)
        secondary:
          'bg-gray-100 text-black border border-gray-200 hover:bg-gray-200 active:bg-gray-300 focus-visible:ring-gray-400 dark:bg-gray-800 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:active:bg-gray-600 dark:focus-visible:ring-gray-500',

        // Outline - Transparent background, black border/text (light mode) / Transparent background, white border/text (dark mode)
        outline:
          'bg-transparent text-black border border-black hover:bg-black hover:text-white active:bg-gray-800 focus-visible:ring-gray-500 dark:text-white dark:border-white dark:hover:bg-white dark:hover:text-black dark:active:bg-gray-100 dark:focus-visible:ring-gray-400',

        // Ghost - No background, no border, just text with hover state
        ghost:
          'bg-transparent text-black border-transparent hover:bg-gray-100 active:bg-gray-200 focus-visible:ring-gray-400 dark:text-white dark:hover:bg-gray-800 dark:active:bg-gray-700 dark:focus-visible:ring-gray-500',

        // Subtle - Slightly different shade from menu background, for less prominent actions
        subtle:
          'bg-neutral-100 text-neutral-700 border-transparent hover:bg-neutral-200 active:bg-neutral-300 focus-visible:ring-neutral-400 dark:bg-neutral-800 dark:text-neutral-300 dark:hover:bg-neutral-700 dark:active:bg-neutral-600 dark:focus-visible:ring-neutral-500',

        // Destructive - Red for dangerous actions
        destructive:
          'bg-red-600 text-white border border-red-600 hover:bg-red-700 active:bg-red-800 focus-visible:ring-red-500 dark:bg-red-700 dark:border-red-700 dark:hover:bg-red-800 dark:active:bg-red-900',

        // Link - Looks like a text link
        link: 'bg-transparent text-black underline-offset-4 hover:underline focus-visible:ring-gray-400 dark:text-white border-transparent p-0 h-auto',
      },
      size: {
        sm: 'h-8 px-3 text-xs',
        md: 'h-9 px-4 text-sm',
        lg: 'h-10 px-6 text-base',
        xl: 'h-12 px-8 text-lg',
        icon: 'h-9 w-9 p-0',
        'icon-xs': 'h-4 w-4 p-0',
        'icon-sm': 'h-8 w-8 p-0',
        'icon-lg': 'h-10 w-10 p-0',
      },
      fullWidth: {
        true: 'w-full',
        false: '',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
      fullWidth: false,
    },
  }
)
